import { isRouteErrorResponse, useRouteError } from 'react-router'
import { useSelector } from 'react-redux'

import { DocumentMeta } from '../components/DocumentMeta'
import { getPlain } from '../store/utils'
import ErrorPage from '../components/ErrorPage'
import Theme from '../components/Theme'

export default function ErrorBoundary() {
  let viewError = useSelector<State, unknown>((state) => state.getIn(['view', 'error']))
  viewError = getPlain(viewError)

  const error = useRouteError()
  const isRouteError = isRouteErrorResponse(error)

  if (isRouteError && error.status === 405) {
    // 405 Method Not Allowed
    // Show generic error page without layout.
    // We cannot show the error page with layout because React Router loaders
    // are not executed for this type of error, so necessary page data required
    // for rendering with layout is not available.
    return (
      <>
        <DocumentMeta />
        <ErrorPage statusCode={error.status} />
      </>
    )
  }

  if (isRouteError) {
    viewError = { ...error, message: error.data?.message ?? '' }
  }

  return <Theme withLayout error={viewError} currentView="error" />
}
